import formPadrao from "@/forms/solicitarOS"
import helpers from "@/cflow/helpers"

const form = helpers.copyJson(formPadrao)
// Definir form como somente leitura:
form.leitura = true
form.dente.modelo.escala.leitura = true
form.dente.modelo.cor.leitura = true
form.dente.modelo.brilho.leitura = true
form.dente.modelo.textura.leitura = true
form.dente.modelo.caracterizacao_oclusal.leitura = true
form.hr1.ignorar = true
form.hr3.ignorar = true
form.h6_1.ignorar = true

export default form